import { api } from "@/lib/api";
import type { Person } from "./use-persons";

/**
 * Hook for fetching detailed information about a single person
 * including associated accounts and opportunities
 */
export function usePersonDetail(personId?: string) {
  return api.useQuery<Person>(`datahub/persons/${personId}/`, {
    enabled: !!personId,
  });
}
